import React from 'react';

import ReactDOM from 'react-dom/client';

import Marketing from '../marketing/Marketing';
import '../shared/styles/index.scss';
import '../shared/styles/marketing.scss';

document.addEventListener('DOMContentLoaded', () => {
  const root = ReactDOM.createRoot(document.getElementById('marketing'));
  root.render(<Marketing />);
});
